export const CONFIG = {
    apiUrl: process.env.REACT_APP_BACK_URL,
    loginUrl: process.env.REACT_APP_LOGIN_URL,
}
